<div *ngIf="showOverlay" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.7); z-index: 9999;">
  <div class="d-flex justify-content-center align-items-center" style="height: 100%;">
    <div class="spinner-border text-white" role="status">
    </div>
  </div>
</div>

<div class="d-flex justify-content-center align-items-center">
  <div class="container-fluid">
    <div class="row d-flex justify-content-center">
      <div class="col-12 col-md-8 col-lg-6">
        <div class="card mt-2 mb-2">
          <div class="card-body p-5 g-3">
            <h4 class="d-inline-block" style="position: relative; top: 0.3rem;" i18n>Sign in / Sign up</h4>
            <p i18n>To complete your order on Nuuduu, you will need an account. Whether you're a new or existing customer, you can log in or sign up below.</p>
            <p i18n>Nuuduu accounts are country-specific. Please make sure you have selected the correct country.</p>
            <div class="row mt-4">
              <div class="col-12">
                <button *ngIf="(platform == 'ios' || platform == 'web')" type="button" class="btn btn-primary w-100 mb-3"
                  (click)="appleSignup()">
                  <img src="assets/images/apple.png" style="height: 1.5rem;">
                  &nbsp;<span i18n>Continue with Apple ID</span>
                </button>
              </div>
              <div class="col-12">
                <button type="button" class="btn btn-primary w-100" (click)="googleSignup()">
                  <img src="assets/images/google.png" style="height: 1.5rem;">
                  &nbsp;<span i18n>Continue with Google</span>
                </button>
              </div>
            </div>
            
            <div class="text-center mt-3 mb-1" i18n>Or enter your email address.</div>

            <form class="mb-3 mt-md-2" [formGroup]="loginForm" (ngSubmit)="loginForm.controls.email.valid ? (existingUserFound ? signin() : existingUser()) : null">
              <div class="mb-3">
                <label for="email" class="form-label" i18n>Email address</label>
                <input #emailInput type="email" class="form-control" id="email"
                  autocomplete="email" inputmode="email" formControlName="email">
              </div>
              <div *ngIf="existingUserFound" class="mb-3">
                <label for="password" class="form-label" i18n>Password</label>
                <div class="input-group">
                  <input #passwordInput [type]="showPassword ? 'text' : 'password'" class="form-control" id="password" autocomplete="current-password"
                    formControlName="password">
                  <button type="button" class="btn btn-primary" style="width: 3.5rem;" (click)="showPassword = !showPassword">
                    <fa-icon [icon]="showPassword ? fa.faEyeSlash : fa.faEye" style="color: #fff;"></fa-icon>
                  </button>
                </div>
              </div>
              <div class="d-grid mb-3">
                <button *ngIf="!existingUserFound" type="submit" class="btn btn-primary mb-3"
                  i18n>Continue</button>
                  <button *ngIf="existingUserFound" type="submit" [disabled]="loginForm.invalid" class="btn btn-primary mb-3"
                  i18n>Continue</button>
                <a *ngIf="existingUserFound" routerLink="/forgot-password" class="btn btn-secondary" i18n>Forgot password?</a>
              </div>
            </form>
            <p class="text-center mb-0" style="position: relative; top: 0rem;">
              <a href="https://nuuduu.com/privacy" (click)="privacyPolicy(); $event.preventDefault();" i18n>Privacy policy</a>
              &nbsp;&bull;&nbsp;
              <a href="https://nuuduu.com/tnc" (click)="tnc(); $event.preventDefault();" i18n>Terms and conditions</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>